import * as i18nIsoCountries from 'i18n-iso-countries';
import { useAppStore } from '@/application/common/app/store';

export function getLocalizedCountryNameForCountryCode(countryCode: string): string {
  return i18nIsoCountries.getName(countryCode, useAppStore().selectedLanguage!);
}
